(function () {
    'use strict';

    angular
        .module('app.dailySetup')
        .factory('bookingHistory.dialog', bookingHistoryDialog);

    bookingHistoryDialog.$inject = ['$uibModal', 'opsIncludeVersion'];
    /* @ngInject */
    function bookingHistoryDialog($uibModal, opsIncludeVersion) {
        var service = {
            display: display
        }
        
        return service;

        function display(item) {
            var modalOptions = {
                templateUrl: 'app/dialogs/_bookingHistory.html?v=' + opsIncludeVersion,
                controller: BookingHistoryModalInstance,
                controllerAs: 'vm',
                keyboard: true,
                size: 'lg',
                resolve: {
                    options: function () {
                        return {
                            item: item
                        };
                    }
                }
            };

            return $uibModal.open(modalOptions).result;
        }
    }


    BookingHistoryModalInstance.$inject = ['$uibModalInstance', 'options', 'common', 'dataservice'];

        /* @ngInject */
    function BookingHistoryModalInstance($uibModalInstance, options, common, dataservice) {
        var vm = this;
        vm.okText = 'Close';
        vm.ok = function () {
            $uibModalInstance.close('ok');
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
       
        activate();

        function activate() {
            var promises = [getItems()];
            return common.$q.all(promises).then(function () {
            }, function (error) { });
        }


        function getItems() {
            return dataservice.getItems('api/DailySetup/HistoryForBooking/' + options.item.BookingId).then(function (response) {
                var data = response.data;
                //common.convertUtcKeysToLocal(data);
                vm.items = data;
                return vm.items;
            }, function (error) { });
        }

    }
})();
